const builtInVoxelDataSources = {
    ServerLevel: 'serverLevel',
    ClientDerived: 'clientDerived',
    DecoderSubResolution: 'decoderSubResolution',
    DirectLoad: 'directLoad',
};
const VoxelDataSources = builtInVoxelDataSources;
export function registerVoxelDataSourcesConstant(name, source) {
    if (Object.prototype.hasOwnProperty.call(VoxelDataSources, name)) {
        throw new Error(`Voxel data source constant "${String(name)}" already exists`);
    }
    VoxelDataSources[name] =
        source;
}
export default VoxelDataSources;
